export default "__VITE_PUBLIC_ASSET__dbf95ac6__"